import React from 'react'
import { Loading } from '@dasa-health/components-react'
import { LoadingContainer } from './styles'

export const FullPageLoading = ({ ...props }) => (
    <LoadingContainer aria-busy="true" aria-live="polite" {...props}>
        <Loading />
    </LoadingContainer>
)
